jQuery(document).ready(function ($) {
  $(window).load(function() { 

    /**
     * Conta cliques no botão de wpp
     */

    $('.jc-lp-chat-button').click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Chat - Whatsapp',
        'eventAction': 'Cliques',
        'eventLabel': ''
      });

      gtag('event', 'LP - Chat - Whatsapp', {
        'eventAction': 'Cliques',
      });
    });

    /**
     * Conta cliques no formulário do banner
     */

    $(".jc-lp-banner-form form input[type='submit']").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Formulário - Banner',
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });

      gtag('event', 'LP - Formulário - Banner', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });

    /**
     * Conta cliques no botão de submit do CTA
     */

    $(".jc-lp-call-to-action form input[type='submit']").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Formulário - CTA',
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });

      gtag('event', 'LP - Formulário - CTA', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });

    /**
     * Conta cliques no botão CTA
     */

    $(".jc-lp-call-to-action a").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - CTA',
        'eventAction': 'Cliques',
        'eventLabel': $(this).text()
      });

      gtag('event', 'LP - CTA', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });
    
    /**
    * Conta o número de cliques nos itens de menu em LP
    */
    
    $('#landing-page-menu a').click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Menu',
        'eventAction': 'Cliques',
        'eventLabel': $(this).text()
      });

      gtag('event', 'LP - Menu', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });
    
    /**
    * Conta o número de cliques no card de um post em LP
    */ 
    
    $('.jc-post-thumb').click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Post - card',
        'eventAction': 'Cliques',
        'eventLabel': $(this).find('.jc-post-thumb-title').text()
      });

      gtag('event', 'LP - Post - card', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).find('.jc-post-thumb-title').text()
      });
    });
    
    /**
    * Conta o número de cliques em botões de compartilhar post em LP
    */
    
    $('.jc-post-thumb-header a').click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Post - card',
        'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
        'eventLabel': $(this).closest('.jc-post-thumb-header').parent().find('.jc-post-thumb-title').text()
      });

      gtag('event', 'LP - Post - card', {
        'eventAction': 'Compartilhar - ' + $(this).data('social-type') ,
        'eventLabel': $(this).closest('.jc-post-thumb-header').parent().find('.jc-post-thumb-title').text()
      });
    });
    
    /**
    * Conta o número de cliques em botões de envio de lead no modal em uma LP
    */
    
    $(".jc-bottom-form-bar-body form input[type='submit']").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Formulário - Modal',
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });

      gtag('event', 'LP - Formulário - Modal', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });
    
    /**
    * Conta o número de cliques em botões de envio de lead em uma LP
    */
    
    $("form input[type='submit']:not(.jc-bottom-form-bar-body form input[type='submit'], .jc-lp-banner-form form input[type='submit'], .jc-lp-call-to-action form input[type='submit'])").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Formulário - Oferta',
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });

      gtag('event', 'LP - Formulário - Oferta', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).val()
      });
    });
    
    /**
     * Conta transições na galeria de imagems
     */

    $('.jc-gallery-photo').on('afterChange', function(slick, currentSlide){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Galeria',
        'eventAction': 'Visualizações',
        'eventLabel' : ( $(this).find('.slick-current').attr("data-slick-index") - (-1) ) + "/" + $(this).find(".slick-slide").length,
        'eventValue': 1
      });

      gtag('event', 'LP - Galeria', {
        'eventAction': 'Visualizações',
        'eventLabel' : ( $(this).find('.slick-current').attr("data-slick-index") - (-1) ) + "/" + $(this).find(".slick-slide").length,
        'eventValue': 1
      });
    });

    /**
     * Conta transições na galeria de vídeos
     */

    $('.jc-gallery-video').on('afterChange', function(slick, currentSlide){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Vídeo',
        'eventAction': 'Visualizações',
        'eventValue': 1
      });

      gtag('event', 'LP - Vídeo', {
        'eventAction': 'Visualizações',
        'eventValue': 1
      });
    });
    
    /**
    * Conta o número de cliques nos botoes de midia social no rodape
    */
    
    $(".jc-footer .jc-socia-media-list-item a").click(function(){
      dataLayer.push({
        'event': 'eventGA',
        'eventCategory': 'LP - Rodapé',
        'eventAction': 'Cliques',
        'eventLabel': $(this).data('social-type')
      });

      gtag('event', 'LP - Rodapé', {
        'eventAction': 'Cliques',
        'eventLabel': $(this).data('social-type')
      });
    });
  });
});

/**
* Atribui os valores do evento de clique nos cliques dos botoes de cta no modal de um formulario em LP
* Função chamada na main.js
*/
function clickEventModalFormLandingPage(text){
  dataLayer.push({
    'event': 'eventGA',
    'eventCategory': 'LP - Formulário - Modal',
    'eventAction': 'Cliques',
    'eventLabel': text,
  });

  gtag('event', 'LP - Formulário - Modal', {
    'eventAction': 'Cliques',
    'eventLabel': text,
  });
}